import Vue from "vue";
import Vuetify from "vuetify";
import { merge } from "lodash";

require("vuetify/dist/vuetify.min.css");

Vue.use(Vuetify);

const baseTheme = {
  theme: {
    themes: {
      light: {
        // error: "#ffc3c3",
        // info: "#cff5f6",
        // success: "#d7f7c2",
        // warning: "#fcedb9",
      },
    },
  },
};

function loadCustomTheme() {
  const locales = require.context(
    `../configs/${process.env.VUE_APP_CONFIG}/theme/`,
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  //
  // eslint-disable-next-line
  const themes: any = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      themes[locale] = locales(key);
    }
  });
  return themes;
}

const configTheme = loadCustomTheme();

const opts = {
  ...merge(baseTheme, configTheme),

  // icons: {
  //   iconfont: "mdi", // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  // },
};

export default new Vuetify(opts);
